module.exports = __webpack_public_path__ + "images/personal-details.cd29e4e4b05f243403b2607a6e7a1fea.png";